/**
 * Command functions that call into WASM.
 *
 * After WASM init, the cmd_* functions are available as named exports
 * from the WASM module. We expose them on window.__gameCommands so the
 * Lit overlay (which loads independently) can call them.
 *
 * The WASM init script in index.html calls registerCommands() after init.
 */

interface GameCommands {
  cmd_menu_select: (index: number) => void;
  cmd_proceed: () => void;
  cmd_nav_prev: () => void;
  cmd_nav_next: () => void;
  cmd_save_exit: () => void;
  cmd_toggle_mode: () => void;
  cmd_open_controls: () => void;
  cmd_open_touch_menu: () => void;
  cmd_close_overlays: () => void;
  cmd_dismiss_modal: () => void;
  cmd_confirm_reset: (confirmed: boolean) => void;
  cmd_show_comment: () => void;
  cmd_restart_stage: () => void;
}

function getCommands(): GameCommands | null {
  return (
    (window as unknown as Record<string, unknown>).__gameCommands as GameCommands | null
  ) ?? null;
}

export function cmdMenuSelect(index: number): void {
  getCommands()?.cmd_menu_select(index);
}

export function cmdProceed(): void {
  getCommands()?.cmd_proceed();
}

export function cmdNavPrev(): void {
  getCommands()?.cmd_nav_prev();
}

export function cmdNavNext(): void {
  getCommands()?.cmd_nav_next();
}

export function cmdSaveExit(): void {
  getCommands()?.cmd_save_exit();
}

export function cmdToggleMode(): void {
  getCommands()?.cmd_toggle_mode();
}

export function cmdOpenControls(): void {
  getCommands()?.cmd_open_controls();
}

export function cmdOpenTouchMenu(): void {
  getCommands()?.cmd_open_touch_menu();
}

export function cmdCloseOverlays(): void {
  getCommands()?.cmd_close_overlays();
}

export function cmdDismissModal(): void {
  getCommands()?.cmd_dismiss_modal();
}

export function cmdConfirmReset(confirmed: boolean): void {
  getCommands()?.cmd_confirm_reset(confirmed);
}

export function cmdShowComment(): void {
  getCommands()?.cmd_show_comment();
}

export function cmdRestartStage(): void {
  getCommands()?.cmd_restart_stage();
}
